<!--
 * @Author       : JiangChao
 * @Date         : 2021-06-28 13:49:34
 * @LastEditors  : JiangChao
 * @LastEditTime : 2021-07-26 10:01:40
 * @Description  :
-->
<template>
  <div>
    <div
      id="service"
      class="research-background-color service-container"
      style="right: -195px"
      @touchmove="handleTouchMove"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
      @click="tokefuMessage"
    >
      <i
        class="icon-font emkt-icon-kefu1 icon-size"
        style="margin-left: 6px"
      ></i>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import emkt from "../../emkt";
import wx from 'wx'
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      display: false,
      touchFlag: false,
    };
  },
  computed: {
    ...mapGetters(["hasLogin"]),
  },
  methods: {
    handleTouchStart(e) {
      this.touchFlag = true;
      this.$emit("preventTouchMove");
    },
    handleTouchMove(e) {
      if (this.touchFlag === false) return;
      let touch = e.touches[0];
      let screenHeight = window.innerHeight;
      let element = document.getElementById("service");
      if (touch.clientY + 45 > screenHeight) {
        element.style.top = screenHeight - 45 + "px";
      } else if (touch.clientY < 0) {
        element.style.top = 0 + "px";
      } else {
        element.style.top = touch.clientY + "px";
      }
    },
    handleTouchEnd() {
      this.touchFlag = false;
      this.$emit("activateTouchMove");
    },
    tokefuMessage() {
      if (this.hasLogin) {
        if (emkt.isWapp) {
          wx.miniProgram.navigateTo({
            url: '/pages/consult/consult'
          })
        } else {
          emkt.openCustomerService()
        }
      } else {
        alert("请您先去登录！");
      }
    },
  },
};
</script>

<style scoped>
.service-container {
  color: #fff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 240px;
  height: 44px;
  border-radius: 22px;
  z-index: 10001;
  position: fixed;
  right: -20px;
  top: 67vh;
  padding: 0 8px;
  transition: 0.5s;
}
.icon-size {
  font-size: 24px;
}
.service-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  background: #000;
  z-index: 10000;
}
.service-group {
  display: flex;
  align-items: center;
  width: 100px;
  justify-content: space-evenly;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// CustomerService.vue?3412b154